import React, { useEffect, useRef, useState, useCallback } from 'react';

const ResponsiveImage = ({ imagePath, leftRightPadding, topBottomPadding, headerCompensate, angularScope }) => {

  const elementRef = useRef(null);
  const imageRef = useRef(null);
  
  const [originalDimensions, setOriginalDimensions] = useState({ width: undefined, height: undefined });

  const resize = useCallback(() => {
    if (!imageRef.current || !elementRef.current) return;
  
    const { clientWidth, clientHeight } = elementRef.current.parentNode;
    
    const lrPadding = leftRightPadding || 0;
    const tbPadding = topBottomPadding || 0;
    const hCompensate = headerCompensate || 0;
  
    const containerWidth = clientWidth - lrPadding;
    const containerHeight = clientHeight - tbPadding;
  
    const imageWidth = imageRef.current.width;
    const imageHeight = imageRef.current.height;
  
    const scaleX1 = containerWidth;
    const scaleY1 = (imageHeight * containerWidth) / imageWidth;
    const scaleX2 = (imageWidth * containerHeight) / imageHeight;
    const scaleY2 = containerHeight;
  
    const scaleOnWidth = scaleX2 > containerWidth;
  
    let width, height;
    
    if (scaleOnWidth) {
      width = scaleX1;
      height = scaleY1;
    } else {
      width = scaleX2;
      height = scaleY2;
    }
  
    const targetLeft = (containerWidth - width) / 2;
    const targetTop = (containerHeight - height) / 2;
  
    elementRef.current.style.cssText = `height: ${height}px;
                                         width: ${width}px;
                                         left: ${targetLeft + lrPadding / 2}px;
                                         top: ${targetTop + tbPadding / 2 - hCompensate}px`;
  }, [leftRightPadding, topBottomPadding, headerCompensate, elementRef, imageRef]);
  

  useEffect(() => {
    
    const handleResize = () => {
      if (!elementRef.current || elementRef.current.parentNode.clientWidth < 200 || elementRef.current.parentNode.clientHeight < 250) return;
      resize();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [resize]);

  useEffect(() => {

    const ir = imageRef.current;

    if(!ir) return;

    const handleImageLoad = () => {
      setOriginalDimensions({
        width: ir.width,
        height: ir.height,
      });

      if (angularScope) {
        angularScope.$broadcast('previewLoaded', { isImage: true });
      }

      resize();
    };

    ir.addEventListener('load', handleImageLoad, { once: true });

    return () => {
      ir.removeEventListener('load', handleImageLoad);
    };
  }, [imagePath, angularScope, resize]);

  return (
    <div ref={elementRef} className="image-preview">
      <img alt="Preview" ref={imageRef} src={imagePath} />
    </div>
  );
};

export default ResponsiveImage;